// extracted by mini-css-extract-plugin
module.exports = {"item":"Notifications_item_3fTnO","count":"Notifications_count_3pKYL","noPadding":"Notifications_noPadding_HM2xT","icon":"Notifications_icon_1sd08"};